<template>
  <div class="container-fluid" id="home">
    <div class="row wrapper">
      <div class="col-12 col-md-4 side-banner">
        <div class="header">
          <div class="company-logo mb-4"></div>
          <div class="hero-image" alt="Your insurance needs"></div>
        </div>
      </div>
      <div class="col-12 col-md-8 main-banner">
        <div class="main">
          <div v-html="pageContent.pages.home.intro"></div>

          <div class="row row-cols-1">

            <b-card class="col mb-2 choice-box p-0">
              <router-link :to="{ name: 'Intro', params: {choice: 'about' } }" tabindex="0" role="button">
                <div class="row align-items-center">
                  <div class="col-2" style="text-align: center;">
                    <i class="icon insurance-needs"></i>
                  </div>
                  <div class="col" v-html="pageContent.pages.home.needsButton">
                  </div>
                  <div class="col-1 pl-0">
                    <div class="next-click"></div>
                  </div>
                </div>
              </router-link>
            </b-card>

            <b-card
              class="col choice-box p-0"
              @click="skipCalculations = true"
              v-show="pageContent.homepageSecondaryCtaType == 'button'" >
              <router-link :to="{ name: 'Intro', params: {choice: 'next-options' } }" tabindex="0" role="button">
                <div class="row align-items-center">
                  <div class="col-2" style="text-align: center;">
                    <i class="icon insurance-cost"></i>
                  </div>
                  <div class="col">
                    <h3>The cost of your cover</h3>
                    <small>
                      Calculate your cover costs based on your {{ pageContent.companyName }} membership.
                    </small>
                  </div>
                  <div class="col-1 pl-0">
                    <div class="next-click"></div>
                  </div>
                </div>
              </router-link>
            </b-card>

            <p
              v-show="pageContent.homepageSecondaryCtaType == 'text'"
              class="p-3 text-secondary-cta"
            >
              Already know how much cover you need? Get straight into calculating the <router-link :to="{ name: 'Intro', params: {choice: 'next-options' } }" tabindex="0" role="button">cost of your cover</router-link>.
            </p>

          </div>
        </div>
      </div>
    </div>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { mapFields } from "vuex-map-fields";
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import CustomFooter from '../components/CustomFooter';

extend('required', {
  ...required,
  params: ['msg'],
  message: '{msg}'
});

export default {
  name: 'Home',
  components: {CustomFooter},
  computed: {
    ...mapFields(["acceptedDisclaimer", "skipCalculations", "prevTab"]),
    ...mapGetters(["pageContent"]),
  },
  methods: {
    resetPrevTab () {
      console.log('resetting')
      this.$store.commit("updatePrevTab", null);
    },
    clickDisclaimer(e) {
      this.$store.commit("updateAcceptedDisclaimer",e.target.checked);
      this.triggerHeightCheck();
    },
    onSubmit () {
      this.$router.push('/intro');
      this.triggerHeightCheck();
    },
    triggerHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
  },
  mounted() {
    this.$refreshIframeHeight();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
    this.resetPrevTab();
  }
};
</script>
